
import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';
import { listenForConnectivityChanges, isOnline } from '@/utils/offlineStorage';

const OfflineIndicator: React.FC = () => {
  const [offline, setOffline] = useState<boolean>(!isOnline());

  useEffect(() => {
    // Update initial state
    setOffline(!isOnline());
    
    // Set up listeners
    const removeListeners = listenForConnectivityChanges(
      () => setOffline(false),
      () => setOffline(true)
    );
    
    // Clean up
    return removeListeners;
  }, []);

  if (!offline) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 flex items-center bg-yellow-500 text-white px-3 py-2 rounded-lg shadow-lg z-50">
      <WifiOff className="h-4 w-4 mr-2" />
      <span className="text-sm font-medium">You're offline. Some content may be limited.</span>
    </div>
  );
};

export default OfflineIndicator;
